

























































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import AgencyGroupDto from '@/models/AgencyGroups/AgencyGroupDto'
import AgencyGroupEdit from '@/components/AgencyGroups/AgencyGroupEdit.vue';
import AgencyGroupCreate from '@/components/AgencyGroups/AgencyGroupCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'AgencyGroups',
  components: { AgencyGroupEdit, AgencyGroupCreate }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentAgencyGroup(null);
    }

    async updateCurrentAgencyGroup(agencyGroup: AgencyGroupDto) {
        AgencySettingsModule.updateCurrentAgencyGroup(agencyGroup);
    }

    get currentAgencyGroup() {
        return AgencySettingsModule.currentAgencyGroup;
    }

    get loading() {
        return AgencySettingsModule.loadingAgencyGroups;
    }

    get agencyGroups() {
        return AgencySettingsModule.agencyGroups;
    }

    async deleteAgencyGroup(group: AgencyGroupDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the group ' + group.name + '?', options);
        // if (result) {
        //     const request = new UpdateAgencyUserStatusRequest();
        //     request.updatedAt = user.updatedAt;
        //     request.status = AgencyUserStatusEnum.Deleted;
        //     await AgencySettingsModule.deleteAgencyUser(request);
        // }
  }
}
